// extracted by mini-css-extract-plugin
export default {"certificate-details__container":"DetailsV2_certificate-details__container__103Tg","details-overflow-wrap":"DetailsV2_details-overflow-wrap__m-VEC"};